import { Component, OnInit, HostListener } from '@angular/core';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {Remesa} from 'src/app/interfaces/remesa.interface';
import {VentaService} from 'src/app/services/venta.service';

@Component({
  selector: 'app-remesa',
  templateUrl: './remesa.component.html',
  styles: [
  ]
})
export class RemesaComponent implements OnInit {

  monto = '0';

  constructor(
    private router: Router,
    public service: VentaService
  ) { }

  ngOnInit(): void {
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {

    if (event.keyCode === 27) {
      this.router.navigate(['/venta']);
    } else if (
      (event.keyCode >= 48 && event.keyCode <= 57) ||
      (event.keyCode >= 96 && event.keyCode <= 105)
    ) {
      this.monto += event.key;

    } else if (event.keyCode === 8) {
      this.monto = '0';

    } else if (event.keyCode === 13) {
      this.guardarRemesa();
    }
  }

  async guardarRemesa() {
    const monto = Number.parseInt(this.monto, 10);
    if (monto > 0) {
      const remesa: Remesa = {
        fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
        monto
      };

      this.service.caja.remesas.push(remesa);

      await this.service.actualizarRemesa();
      this.router.navigateByUrl('/venta');
      
    }
  }
}
